module.exports = __webpack_public_path__ + "static/media/Readytogo.c68570c6.PNG";